// jest-dom 을 사용하면서 테스트 환경에서도 global.window 가 존재합니다. 테스트는 서버에서 실행되기 때문에 해당 처리를 추가합니다.
export const IS_CLIENT_SIDE =
  process?.env?.JEST_WORKER_ID === undefined && typeof window !== 'undefined';
